<template>
    <div class="projectServicesTop">
        <div class="projectServicesImg" :style="{ background: 'url('+ banner +') center center no-repeat',backgroundSize:'cover'}">
            <div class="projectServicesContent">
                <div class="projectServicesList">
                    <div 
                    :class="code==item.menuCategory?'projectServicesItem activeStyle':'projectServicesItem'" 
                    v-for="(item,index) in dataList" 
                    :key="index" 
                    @click="changRoutes(item)"
                    >
                        {{item.name}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import $ from "jquery";
export default {
    name: "TemplateTop",
    props:['code'],
    data() {
        return {
            banner:"https://jhwlgw.oss-cn-shanghai.aliyuncs.com/temp/图层 13_1649324324234.png",
            dataList:[]
        };
    },
    watch:{

    },
    mounted() {
        if(sessionStorage.getItem("activeMenu")){
            var activeMenu =  JSON.parse(sessionStorage.getItem("activeMenu"));
            this.banner = activeMenu.image;
            this.dataList = activeMenu.childs;
        }
    },
    methods: {
        changRoutes(sub){
            var path =  sub.href?sub.href:"/contentPage";
            var code = sub.menuCategory;
            this.$router.push({
                path: path,
                query:{
                    code:code
                }
            });
            this.$emit('onClick',sub);
        }
    },
};
</script>
<style lang="less" scoped>
.projectServicesTop {
    width: 100%;
    .projectServicesImg {
        width: 100%;
        height: 420px;
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        position: relative;
        .projectServicesContent {
            position: absolute;
            left: 0;
            bottom: 0;
            background-color: rgba(255, 255, 255, 0.8);
            width: 100%;
            .projectServicesList {
                margin: 0 auto;
                max-width: 1100px;
                display: flex;
                align-items: center;
                justify-content: center;
                .projectServicesItem {
                    cursor: pointer;
                    font-size: 16px;
                    letter-spacing: 1px;
                    color: #333;
                    padding: 17px 28px;
                    &:hover{
                        color: #2C9F6E;
                    }
                }
                .activeStyle {
                    background-color: #2C9F6E;
                    color: #fff;
                    font-weight: bold;
                    pointer-events:none;
                    &:hover{
                        background-color: #2C9F6E;
                        color: #fff;
                    }
                }
            }
        }
    }
}
</style>
